import { render, staticRenderFns } from "./exportHistory.vue?vue&type=template&id=5240d666&scoped=true"
import script from "./exportHistory.vue?vue&type=script&lang=js"
export * from "./exportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240d666",
  null
  
)

export default component.exports